<script>
export default {
  data () {
    return {
      RS_TIMER: null,
      // window
      windowWidth: 0,
      windowHeight: 0,
      // layout
      headerHeight: 0,
      footerHeight: 0,
      scrollbarSize: 0
    }
  },
  computed: {
    windowType () {
      return (
        this.windowWidth > this.tabletWidth ? 'default' : 
        this.windowWidth > this.mobileWidth ? 'tablet' : 'mobile'
      )
    },
    layoutStyles () {
      return {
        '--window-height': this.windowHeight + 'px',
        '--window-width': this.windowWidth + 'px',
        '--header-height': this.headerHeight + 'px',
        '--footer-height': this.footerHeight + 'px',
        '--scrollbar-size': this.scrollbarSize + 'px',
        '--content-max-width': this.contentMaxWidth + 'px',
        '--content-min-width': this.contentMinWidth + 'px',
        '--respond-width': this.respondWidth + 'px',
        '--tablet-width': this.tabletWidth + 'px',
        '--mobile-width': this.mobileWidth + 'px'
      }
    },
    // static
    contentMaxWidth () { return 1220 },
    contentMinWidth () { return 0 },
    respondWidth () { return 1600 },
    tabletWidth () { return 1440 },
    mobileWidth () { return 900 }
  },
  created () {
    const handler = () => {
      this.RS_TIMER && clearTimeout(this.RS_TIMER)
      if (window.innerHeight * Math.min(1, window.devicePixelRatio / 2) > window.screen.height) {
        this.RS_TIMER = setTimeout(() => {
          this.RS_TIMER = null
          window.dispatchEvent(new Event('resize'))
        }, 100)
      } else {
        this.windowWidth = window.innerWidth
        this.windowHeight = window.innerHeight
        this.headerHeight = { 'default': 72, 'tablet': 72, 'mobile': 60 }[this.windowType]
        this.footerHeight = 0
        this.scrollbarSize
      }
    }
    document.addEventListener('visibilitychange', handler)
    window.addEventListener('DOMContentLoaded', handler)
    window.addEventListener('resize', handler)
    window.dispatchEvent(new Event('resize'))
  },
  methods: {
    responseDisplay (types) {
      types = (types instanceof Array) ? types : [types]
      const typeMap = {
        'desktop': ['default'],
        'handheld': ['tablet', 'mobile']
      }
      return Array.prototype.concat.apply([], types.map(type => typeMap[type] || [type])).includes(this.windowType)
    }
  }
}
</script>
